import React from 'react';
import { PrismicAccountSavedBoards } from '../../types/prismic';
import Box, { Header, IconBox } from './Box';

type Props = {
  savedBoardsEnabled: boolean;
  userId: string;
  content: PrismicAccountSavedBoards;
};

const SavedBoards = ({ savedBoardsEnabled, userId, content }: Props) => {
  return (
    <Box
      enabled={savedBoardsEnabled}
      href={`/favorites/${userId}`}
      footnote={!savedBoardsEnabled && <>{content.data.account_boards_footnote}</>}
    >
      <IconBox>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38.147"
          height="38.147"
          viewBox="0 0 38.147 38.147"
        >
          <g id="np_portfolio_1650768_000000" transform="translate(-3.125 -3.125)">
            <path
              id="Path_546"
              data-name="Path 546"
              d="M9.375,9.375h1.272v1.272H9.375Z"
              transform="translate(-3.707 -3.707)"
              fill="#ab5742"
            />
            <path
              id="Path_547"
              data-name="Path 547"
              d="M15.625,9.375H16.9v1.272H15.625Z"
              transform="translate(-7.414 -3.707)"
              fill="#ab5742"
            />
            <path
              id="Path_548"
              data-name="Path 548"
              d="M21.875,9.375h1.272v1.272H21.875Z"
              transform="translate(-11.121 -3.707)"
              fill="#ab5742"
            />
            <path
              id="Path_549"
              data-name="Path 549"
              d="M36.186,24.742V3.125H3.125v35.6h17.8v2.543H41.272V24.742ZM34.915,4.4V8.211H4.4V4.4ZM4.4,37.458V9.483H34.915V24.742H20.927V37.458ZM40,40H22.2V26.013H40Z"
              fill="#ab5742"
            />
            <path
              id="Path_550"
              data-name="Path 550"
              d="M12.5,35.173H23.944V25H12.5Zm1.272-8.9h8.9V33.9h-8.9Z"
              transform="translate(-5.56 -12.974)"
              fill="#ab5742"
            />
            <path
              id="Path_551"
              data-name="Path 551"
              d="M58.319,25H46.875V35.173H58.319Zm-1.272,8.9h-8.9V26.272h8.9Z"
              transform="translate(-25.948 -12.974)"
              fill="#ab5742"
            />
            <path
              id="Path_552"
              data-name="Path 552"
              d="M12.5,66.423H23.944V56.25H12.5Zm1.272-8.9h8.9v7.629h-8.9Z"
              transform="translate(-5.56 -31.508)"
              fill="#ab5742"
            />
            <path
              id="Path_553"
              data-name="Path 553"
              d="M68.321,71.652,64,67.329l-3.179,1.907-4.7-4.7-2.988,6.04v4.578h15.2Zm-1.208,2.225H54.4V70.826l2.1-4.2,5.086,5.086.89-.89-.7-.7,2.035-1.208,3.306,3.306Z"
              transform="translate(-29.655 -36.42)"
              fill="#ab5742"
            />
            <path
              id="Path_554"
              data-name="Path 554"
              d="M70.658,66.315a1.907,1.907,0,1,0-1.907-1.907A1.873,1.873,0,0,0,70.658,66.315Zm0-2.543a.636.636,0,1,1-.636.636A.6.6,0,0,1,70.658,63.772Z"
              transform="translate(-38.922 -35.215)"
              fill="#ab5742"
            />
          </g>
        </svg>
      </IconBox>
      <Header>{content.data.account_boards_header}</Header>
      <p>{content.data.account_boards_description}</p>
    </Box>
  );
};

export default SavedBoards;
